
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'
import { Toaster } from "@/components/ui/toaster"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FullscreenProvider } from './contexts/FullscreenContext'

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <FullscreenProvider>
          <Toaster />
          <App />
        </FullscreenProvider>
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>
)
